import React from 'react';


class ColorSelectItem extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e) {
        e.preventDefault();
        this.props.onColorSelect(this.props.color);
    }

    render() {

        const colorStyle = {
            backgroundColor: this.props.color.color_hex
        };

        return (
            <a 
                onClick={this.handleSelect} 
                href="#" 
                className={"color_select_item" + (this.props.active ? ' active' : '')} 
                style={colorStyle}
            >
                <span>{this.props.color.title}</span>
            </a>
        );
    }
  }
export default ColorSelectItem;



// WEBPACK FOOTER //
// ./src/ColorSelectItem.js